<app-form-delegaterights
    [result]="selectedResult"
    [groupList]="groupList"
    [userList]="userList"
    [delegateList]="delegateList"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-delegaterights>

